import axios from "axios";
import moment from "moment";


function capitalize(text) {
  return text.replace(/(?:^|\s)\S/g, word => word.toUpperCase());
}

function format(date,format = 'MM/DD/YYYY'){
  return date.format(format);
}

function creditCardvalidation(card_num) {
  card_num = card_num.replace(/ +|_+/g, "");
  console.log(card_num);
  var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
  var amexpRegEx = /^(?:3[47][0-9]{13})$/;
  var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
  var isValid = false;

  if (
    visaRegEx.test(card_num) ||
    mastercardRegEx.test(card_num) ||
    amexpRegEx.test(card_num) ||
    discovRegEx.test(card_num)
  ) {
    isValid = true;
  }
  if (isValid) {
    console.log("valid card", isValid);
    return true;
  } else {
    console.log("invalid card", isValid);
    return false;
  }
}

function getCreditCardType(accountNumber) {
  //start without knowing the credit card type
  var result = "unknown";

  //first check for MasterCard
  if (/^5[1-5]/.test(accountNumber)) {
    result = "mastercard";
  }

  //then check for Visa
  else if (/^4/.test(accountNumber)) {
    result = "visa";
  }

  //then check for AmEx
  else if (/^3[47]/.test(accountNumber)) {
    result = "amex";
  }

  return result;
}

function getStates() {
  return [
    {
      name: "Alabama",
      abbreviation: "AL"
    },
    {
      name: "Alaska",
      abbreviation: "AK"
    },
    {
      name: "Arizona",
      abbreviation: "AZ"
    },
    {
      name: "Arkansas",
      abbreviation: "AR"
    },
    {
      name: "California",
      abbreviation: "CA"
    },
    {
      name: "Colorado",
      abbreviation: "CO"
    },
    {
      name: "Connecticut",
      abbreviation: "CT"
    },
    {
      name: "Delaware",
      abbreviation: "DE"
    },
    {
      name: "District of Columbia",
      abbreviation: "DC"
    },
    {
      name: "Florida",
      abbreviation: "FL"
    },
    {
      name: "Georgia",
      abbreviation: "GA"
    },
    {
      name: "Hawaii",
      abbreviation: "HI"
    },
    {
      name: "Idaho",
      abbreviation: "ID"
    },
    {
      name: "Illinois",
      abbreviation: "IL"
    },
    {
      name: "Indiana",
      abbreviation: "IN"
    },
    {
      name: "Iowa",
      abbreviation: "IA"
    },
    {
      name: "Kansas",
      abbreviation: "KS"
    },
    {
      name: "Kentucky",
      abbreviation: "KY"
    },
    {
      name: "Louisiana",
      abbreviation: "LA"
    },
    {
      name: "Maine",
      abbreviation: "ME"
    },
    {
      name: "Maryland",
      abbreviation: "MD"
    },
    {
      name: "Massachusetts",
      abbreviation: "MA"
    },
    {
      name: "Michigan",
      abbreviation: "MI"
    },
    {
      name: "Minnesota",
      abbreviation: "MN"
    },
    {
      name: "Mississippi",
      abbreviation: "MS"
    },
    {
      name: "Missouri",
      abbreviation: "MO"
    },
    {
      name: "Montana",
      abbreviation: "MT"
    },
    {
      name: "Nebraska",
      abbreviation: "NE"
    },
    {
      name: "Nevada",
      abbreviation: "NV"
    },
    {
      name: "New Hampshire",
      abbreviation: "NH"
    },
    {
      name: "New Jersey",
      abbreviation: "NJ"
    },
    {
      name: "New Mexico",
      abbreviation: "NM"
    },
    {
      name: "New York",
      abbreviation: "NY"
    },
    {
      name: "North Carolina",
      abbreviation: "NC"
    },
    {
      name: "North Dakota",
      abbreviation: "ND"
    },
    {
      name: "Ohio",
      abbreviation: "OH"
    },
    {
      name: "Oklahoma",
      abbreviation: "OK"
    },
    {
      name: "Oregon",
      abbreviation: "OR"
    },
    {
      name: "Pennsylvania",
      abbreviation: "PA"
    },
    {
      name: "Rhode Island",
      abbreviation: "RI"
    },
    {
      name: "South Carolina",
      abbreviation: "SC"
    },
    {
      name: "South Dakota",
      abbreviation: "SD"
    },
    {
      name: "Tennessee",
      abbreviation: "TN"
    },
    {
      name: "Texas",
      abbreviation: "TX"
    },
    {
      name: "Utah",
      abbreviation: "UT"
    },
    {
      name: "Vermont",
      abbreviation: "VT"
    },
    {
      name: "Virginia",
      abbreviation: "VA"
    },
    {
      name: "Washington",
      abbreviation: "WA"
    },
    {
      name: "West Virginia",
      abbreviation: "WV"
    },
    {
      name: "Wisconsin",
      abbreviation: "WI"
    },
    {
      name: "Wyoming",
      abbreviation: "WY"
    }
  ];
}
function formatPrice(price) {
  return `$ ${(price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

function isEmailDomain(emailDomainVar) {
  var regEmail = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|edu|mil|biz|info|mobi|name|aero|jobs|museum|online|us|kr|ru|io|co|uk|ca)\b/;

  return regEmail.test(String(emailDomainVar).toLowerCase());
}

function isPhoneNumber(phoneNumberVar) {
  var regPhoneNumber = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
  return regPhoneNumber.test(phoneNumberVar);
}

const getData = (function() {
  return async url => {
    const { data } = await axios.get(url);
    console.log("🔎 requesting...");
    return data;
  };
})();

const getAndCache = (function() {
  const cache = {};
  return async (keyCache, url) => {
    if (cache[keyCache]) {
      console.log("💾 from cache...");
      return Promise.resolve(cache[keyCache]);
    }
    const { data } = await axios.get(url);
    console.log("🔎 fresh request...");
    cache[keyCache] = data;
    return data;
  };
})();

const postData = (function() {
  return async (url, payload) => {
    const { data } = await axios.post(url, payload);
    console.log("🔎 requesting...");
    return data;
  };
})();

export {
  capitalize,
  formatPrice,
  getData,
  getAndCache,
  postData,
  isEmailDomain,
  isPhoneNumber,
  creditCardvalidation,
  getCreditCardType,
  getStates,
    format
};



// WEBPACK FOOTER //
// ./src/modules/utils/index.js